module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAVCAYAAAC33pUlAAAAtklEQVRIib3WwQkCMRBG4T9gGdvJsuVYgtbj3QIsQ+96tAMLeB7WgRDcJJvZ7IPcBj4IDEwA1LGjpJuktyQJ6PVOzD2BAeiGGWS9gGEPCOADjHtB09bfeM5BW2JFaCusCkqxCbgAhx5QjE2/IYBrJbgKMmyMIKsEroYMG5i3PG0JbIIMWwM2QzFWA7qgFMuBDy/0D8uBLmgJK4FNUA5bApuhEpaCLqgGM/DuhQAFqLpBgiT3sfIFB++JPUO081AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./images/host/icon-ok.png
// module id = 217
// module chunks = 16